module.exports = __webpack_public_path__ + "img/workload.604325f1.svg";